export default "__VITE_ASSET__c358bfa2__"